export const sectionRoute = {
  path: `/section/:id`,
  link: (sectionId: string | number) => `/section/${sectionId}`,
};
